import PropTypes from 'prop-types';

// material-ui
import { Box } from '@mui/material';

// project import
import MainCard from 'ui-component/cards/MainCard';

// ==============================|| AUTHENTICATION CARD WRAPPER ||============================== //

const AuthCardWrapper = ({ children, ...other }) => (
    <MainCard
        sx={{
            maxWidth: { xs: '100%', sm: 480, md: 520 },
            width: '100%',
            margin: 0,
            boxShadow: '0 4px 20px 0 rgba(0,0,0,0.08)',
            borderRadius: 3,
            border: 'none',
            backgroundColor: (theme) => theme.palette.mode === 'dark' 
                ? theme.palette.background.paper
                : '#ffffff',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
        content={false}
        {...other}
    >
        <Box sx={{ p: { xs: 3, sm: 4, md: 5 } }}>{children}</Box>
    </MainCard>
);

AuthCardWrapper.propTypes = {
    children: PropTypes.node
};

export default AuthCardWrapper;
